export class ToastrComponents
{
    constructor()
    {
        this.objects = $(".toastr-obj");
        this.positionClass = "toast-top-right";
        this.showDuration = "500";
        this.hideDuration = "500";
        this.showMethod = "slideDown";
        this.hideMethod = "slideUp";
        this.timeOut = "3000";
    }

    executaToastrsIniciais()
    {
        var self = this;
        this.objects.each(function(index, element) {
            var type = $(element).data('type');
            var title = $(element).data('title');
            var slot = $(element).data('slot');
            self.executaToastr(type, title, slot);
        });
    }

    executaToastr(type, title, slot)
    {
        switch (type) {
            case "success":
                toastr.success(slot, title, {
                    positionClass: this.positionClass,
                    showDuration: this.showDuration,
                    hideDuration: this.hideDuration,
                    showMethod: this.showMethod,
                    hideMethod: this.hideMethod,
                    timeOut: this.timeOut
                });
                break;
            case "info":
                toastr.info(slot, title, {
                    positionClass: this.positionClass,
                    showDuration: this.showDuration,
                    hideDuration: this.hideDuration,
                    showMethod: this.showMethod,
                    hideMethod: this.hideMethod,
                    timeOut: this.timeOut
                });
                break;
            case "warning":
                toastr.warning(slot, title, {
                    positionClass: this.positionClass,
                    showDuration: this.showDuration,
                    hideDuration: this.hideDuration,
                    showMethod: this.showMethod,
                    hideMethod: this.hideMethod,
                    timeOut: 0
                });
                break;
        }
    }
};